import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16c0c4b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistics-view" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 加载中... ")
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "总抽卡次数", -1))
const _hoisted_7 = { class: "fs-3 fw-bold text-primary" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "总收入", -1))
const _hoisted_10 = { class: "fs-3 fw-bold text-success" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "体力消耗", -1))
const _hoisted_13 = { class: "fs-3 fw-bold text-warning" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "保底次数", -1))
const _hoisted_16 = { class: "fs-3 fw-bold text-danger" }
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "稀有度分布", -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "每日趋势（近7天）", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_icon, { class: "is-loading" }, {
            default: _withCtx(() => [
              _createVNode(_component_Loading)
            ]),
            _: 1
          }),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_el_row, {
            gutter: 20,
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "hover" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.statistics.total_draws || 0), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "hover" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, "¥" + _toDisplayString((_ctx.statistics.total_revenue || 0).toFixed(2)), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "hover" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.statistics.total_energy_consumed || 0), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { shadow: "hover" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.statistics.guaranteed_draws || 0), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_table, {
              data: _ctx.statistics.rarity_distribution || [],
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "稀有度",
                  width: "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_tag, {
                      type: _ctx.getRarityTagType(row.rarity),
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.rarity_display || row.rarity), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "count",
                  label: "次数",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, { label: "占比" }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_progress, {
                      percentage: row.percentage,
                      format: () => `${row.percentage.toFixed(2)}%`,
                      "stroke-width": 10
                    }, null, 8, ["percentage", "format"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          (_ctx.statistics.daily_draws && _ctx.statistics.daily_draws.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_el_table, {
                  data: _ctx.statistics.daily_draws,
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "date",
                      label: "日期",
                      width: "120"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "count",
                      label: "抽卡次数",
                      width: "100"
                    }),
                    _createVNode(_component_el_table_column, { label: "收入" }, {
                      default: _withCtx(({ row }) => [
                        _createTextVNode(" ¥" + _toDisplayString((row.revenue || 0).toFixed(2)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}